export default "__VITE_ASSET__c909c3b0__"